import * as React from 'react';
import * as ReactDOM from 'react-dom';

import App from './app';

if ((module as any).hot) {
  (module as any).hot.accept();
}

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.tsx